<template>
  <div class="content" style="position: relative;
  width: 3000px;
  height: 1200px;
  font-size: 16px;
  background: green;
  overflow: hidden;">
      <!-- <img class="background" style="
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  margin-bottom: -3px;" src="../../assets/background-1216.jpg"> -->
    <div class="body" style="position: relative;
  width: 40%;
  height: 80%;
  overflow: hidden;
  left: 30%;
  top: 45%;
  transform: scale(1.2);">
      <!-- 自定义轮播组件 -->
      <div class="custom-carousel" ref="carousel">
        <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <!-- 第一页 -->
          <div class="carousel-page">
            <div class="con1"
            v-if="data.length > 0"
            style="
        position: absolute;
        top: 0;
        left: 8%;
        height: 100%;
        width: 38%;">
            <div
              class="list"
              v-for="(item, i) in data" :key="item.id"
              :style="{
                top: i * topPosition + '%',
                zIndex: i,
                height: topPosition + '%'
              }"
              style="
              position: absolute;
              left: 0;
              width: 100%;
              display: flex;
              align-items: center;"
              >
              <div
              style="
                position: absolute;
                right: -98px;
                top: 21px;
                width: auto;
                height: 60%;
              "><img style="height: 100%; width: auto;" src="../../assets/vs.png"></div>
              <!-- <div class="item-inner paiming" style="
        display: flex;
        align-items: center;
        height: 100%;
        height: calc( 100% - 10px);
        color: #8c61ff;
        text-align: center;"><div style="
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #fff;
          line-height: 30px;
          font-weight: bold;">{{i + 1}}</div></div> -->
              <div class="item-inner logo"style="
      display: flex;
      align-items: center;
      height: 50%;
      margin: 0 10px;
      width: auto;
      aspect-ratio: 1/1;
      position: relative;">
                <!-- <img
                v-if="item.total > data2[i].total && item.total !== data2[i].total"
                style="
                position: absolute;
                top: -47%;
                left: -16%;
                height: 80%;
                width: auto;
                " class="huangguan" src="../../assets/huangguan.png"> -->
                <img :src="item.id === 23 ? xinyang : item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`" style="
        width: 100%;
        height: auto;
        border: 1px solid #fff;
        border-radius: 50%;">
              </div>
              <div
                :class="`item`"
                style="
      position: relative;
      color: #fff;
      width: 100%;
      height: 40%;
      display: flex;
      flex-direction: row;"
              >
                <div
                  class="item-inner total"
                  :style="{
                    background: item.total > data2[i].total || item.total === data2[i].total ? '#8c61ff' : '#aaa'
                  }"
                  style="
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 16px;
      width: 100%;
      text-align: right;
      justify-content: space-between;
      line-height: 18px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #fff;
      border-radius: 4px;
      padding: 0 5px;"
                >
                <!-- 
      text-shadow: rgb(255 0 255) -1px -1px 3px, rgb(255 0 255) 1px 1px 3px;
      box-shadow: rgba(255, 93, 255, 1) -3px -3px 5px, rgba(0, 0, 0, 0.3) 6px 6px 3px; -->
                  <div class="item-inner nickname"
                            style="
                  display: flex;
                  align-items: center;
                  height: 100%;
                  font-size: 18px;
                  font-weight: bold;
                  font-style: italic;
                  justify-content: space-between;">
                    <span>{{item.nickname }}</span>
                  </div>
                  <div class="total-inner"
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      position: relative;
                      border-radius: 4px 0 0 4px;
                      font-size: 18px;
                  ">
                    <span>{{ item.total.toFixed(0) }}</span>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div class="con2"
              v-if="data2.length > 0"
              style="
          position: absolute;
          top: 0;
          left: 54%;
          height: 100%;
          width: 38%;">
              <div
                class="list"
                v-for="(item, i) in  data2.slice(0, 16)" :key="item.id"
                :style="{
                  top: i * topPosition + '%',
                  zIndex: i,
                  height: topPosition + '%'
                }"
                style="
        position: absolute;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;"
                >
                <!-- <div class="item-inner paiming" style="
          display: flex;
          align-items: center;
          height: 100%;
          height: calc( 100% - 10px);
          color: #8c61ff;
          text-align: center;"><div style="
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #fff;
            line-height: 30px;
            font-weight: bold;">{{i + 1}}</div></div> -->
                <div class="item-inner logo"style="
        display: flex;
        align-items: center;
        height: 50%;
        margin: 0 10px;
        width: auto;
        aspect-ratio: 1/1;
        position: relative;">
                  <!-- <img
                  v-if="item.total > data[i].total && item.total !== data[i].total"
                  style="
                  position: absolute;
                  top: -47%;
                  left: -16%;
                  height: 80%;
                  width: auto;
                  " class="huangguan" src="../../assets/huangguan.png"> -->
                  <img :src="item.id === 23 ? xinyang : item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`" style="
          width: 100%;
          height: auto;
          border: 1px solid #fff;
          border-radius: 50%;">
                </div>
                <div
                  :class="`item`"
                  style="
        position: relative;
        color: #fff;
        width: 100%;
        height: 40%;
        display: flex;
        flex-direction: row;"
                >
                  <div
                    class="item-inner total"
                  :style="{
                    background: item.total > data[i].total || item.total === data[i].total ? '#8c61ff' : '#aaa'
                  }"
                    style="
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
        width: 100%;
        text-align: right;
        justify-content: space-between;
        line-height: 18px;
        box-sizing: border-box;
        position: relative;
        border: 1px solid #fff;
        border-radius: 4px;
        padding: 0 5px;"
                  >
                  <!-- 
        text-shadow: rgb(255 0 255) -1px -1px 3px, rgb(255 0 255) 1px 1px 3px;
        box-shadow: rgba(255, 93, 255, 1) -3px -3px 5px, rgba(0, 0, 0, 0.3) 6px 6px 3px; -->
                    <div class="item-inner nickname"
                              style="
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 18px;
                    font-weight: bold;
                    font-style: italic;
                    justify-content: space-between;">
                      <span>{{item.nickname }}</span>
                    </div>
                    <div class="total-inner"
                      style="
                        height: 100%;
                        display: flex;
                        align-items: center;
                        position: relative;
                        border-radius: 4px 0 0 4px;
                        font-size: 18px;
                    ">
                      <span>{{ item.total.toFixed(0) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播指示器 -->
    <!-- <div class="carousel-indicators">
      <span
        v-for="(page, index) in 2"
        :key="index"
        :class="{ active: currentIndex === index }"
        @click="goToPage(index)"
      >{{index +1}}</span>
    </div>
    <div class="pause-con">
      <button @click="pauseClick">{{ pause ? '启动' : '暂停'}}</button>
    </div> -->
  </div>
</template>

<script>
// import { Carousel } from 'ant-design-vue'
import { cloneDeep } from 'lodash'
import userList from './data-1216'
import userList1 from './data-women'
import userList2 from './data-man'
import axios from '../axios-instance'
import moment from 'moment'

const limit = 12.5
export default {
  name: 'page1216',
  // components: {'a-carousel': Carousel},
  watch: {
  },
  data () {
    return {
      data: [
        // {
        //   id: 1,
        //   nickname: '张三',
        //   account: 'zhangsan',
        //   total: 0,
        //   color: '#ff40f8',
        //   img: require('../../assets/logo.png')
        // }
      ],
      data2: [],
      data3: [],
      maxNum: 10000,
      maxNum2: 10000,
      maxNum3: 10000,
      currentDate: moment().format('MM月DD日'),
      topPosition: limit,
      interval: undefined,
      heigth: limit,
      limit,
      animating: false,
      animating2: false,
      animating3: false,
      pendingData: [],
      subscription: null,
      stompClient: null,
      init: false,
      itemWidth: 50,
      userList: [],
      startTime: null,
      endTime: null,
      imgList: {},
      touxiang: require('../../assets/touxiang.png'),
      xinyang: require('../../assets/xinyang.jpg'),
      dayTotal: 0,
      monthTotal: 0,
      currentIndex: 0,
      carouselInterval: null,
      pause: false,
      group1: [
        {
          "id": 1,
          "nickname": "小美·716",
          "userId": "1954365742",
          "type": 2,
          "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/04/05/BMjAyNTEwMDQwNTAzMTNfMTk1NDM2NTc0Ml8xX2hkMTg4Xzc3OQ==_s.jpg",
          "cookie": "sid=kuaishou.shop.b; did=web_8y8w9500elf71vtj3qmxj5o5zkkn1zd2; bUserId=1000277756247; userId=1954365742; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAHBV2MPzfliLNGqqIosaQUDj_IPvm114LBLNEoTitW4u0psveiuCWNVJpCwpgtJrTYmoB8p-SLCb5TxB1OBFglJOakSkEzB9thmbncLOax6xVbyGJXDYqQpsGN8wftXV0wzTQr-aW726HLWDMyQSQ14GUlijznfIsMZcCzMUFNNG6gn2cHdv99DsvzX0HxcgZ_Qn0hcKB-MZWkC-Dbp87ozGhLSubyi-uEBAthqCoUoWxNxjR0iIJLVoLThwRE9HbpdTex2dzmM72e1H2CXG-4_U5S9BWsMKAUwAQ; kuaishou.shop.b_ph=3a89a3f7a7e828b70d53956a7fec442dda63; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAX9kA3rpgJXgcG9IvC74u-fU1SCeQotQQ8AQB_rYShbtFQOyPjgr0UMDx6JXrLJu5Qa4JGfLZ5ITEshLWxnitSQd2FOnOHCJwBJVJjcXYnldfvPOz23suCXExgd6f7s4fDNIfnLxKerznajrQ0PE87p5uGjn8xjsgeuHZBD8D9Fohix3m077afk-JtNi6Uy7wF1e6T-5sdqs0_3J5nuWzII9DaDQ7SQCPQ7_s77seDPlGhKfnYlfKFPaF-z---LLO1WfrxQiIGFgCp8RMZYh6304Pm7GSkU9lDzSP0oBI1Z7GBR_RfwRKAUwAQ; kuaishou.ad.analysis_ph=308b54520816d69462055abf1a5e5736aa25\n",
          "gmvTodayAmountDouble": 0,
          "diveAmount": 99999,
          "giftTodayAmountDouble": 0,
          "createTime": 1744725047000
        },
        {
          "id": 29,
          "nickname": "牌晓亮.716",
          "userId": "45672093",
          "type": 3,
          "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/10/05/19/BMjAyNTEwMDUxOTEyMDNfNDU2NzIwOTNfMV9oZDE0M18xMTI=_s.jpg",
          "cookie": "1",
          "gmvTodayAmountDouble": 0,
          "diveAmount": 600000,
          "giftTodayAmountDouble": 0,
          "createTime": 1744725047000
        }
      ],
      group2: [
        {
          "id": 2,
          "nickname": "娇妹儿",
          "userId": "2131929203",
          "type": 2,
          "img": "https://p2-pro.a.yximgs.com/uhead/AB/2025/11/25/01/BMjAyNTExMjUwMTEwNDVfMjEzMTkyOTIwM18xX2hkOTNfMzAw_s.jpg",
          "cookie": "sid=kuaishou.shop.b; did=web_8y8w9500elf71vtj3qmxj5o5zkkn1zd2; bUserId=1000015505141; userId=2131929203; kuaishou.shop.b_st=ChJrdWFpc2hvdS5zaG9wLmIuc3QSoAGEfrRGzYH2oyVdvhXVQy5eeVML8D3fXMp0uaZLCl6aG-H3bOeZDTKyNwU4dS8OLaLk3Az9ch97KMW8tTqIdjFm3ormYG4iz-bwoBRXken99GIXh7dHExbN1iK3v4qWPXGRkJeOLZIVESYSber8Jvw1vAKCU2BplhVlrt0OOvKSw1BvHICXU5GP5rJFee9ZALmZmdo5PZ5PC2kWBQwIuH9bGhItLX8o8yblZLeUpJbxgb-W1KYiILRtTf-ATwK072gZ_Bld6wtkBMYD7KObRjIWYMfqQQJDKAUwAQ; kuaishou.shop.b_ph=20632c8de541bacf48f8dab0151998c7c81a; kuaishou.ad.analysis_st=ChdrdWFpc2hvdS5hZC5hbmFseXNpcy5zdBKwAQRjzGLSv5kEXAAPjjLj_03ev-366b0ZbEvMY-FIUp8BNlH1IgLRBGQnopJ2O7T3kvU8Fqn6_I3Z2n10Ugt9zk-JcwNMm2ULxoeCcSjLRm7caiZ4BECHzZsVEEBgjjRPr4DQlOjQk9CpOy9m5-sibl4ulI0EYmteu95ALS9CuNokycYGryw85T0mgVSnpZQm5YPaCApavPaqV7_W5kMxy7CQQK2ivRH4s8UpinYElKPEGhI2Q4Zf7Fjy6K-OkplcWEkYXd8iIPCtAaXPIxDpMgarf8l43CnlsbPp9HLWGbVOwjsG3L4vKAUwAQ; kuaishou.ad.analysis_ph=5db6e23abc97035186e9c9f95dc5cca56fd4\n",
          "gmvTodayAmountDouble": 0,
          "diveAmount": 99999,
          "giftTodayAmountDouble": 0,
          "createTime": 1744725047000
        },
        {
          "id": 23,
          "nickname": "辛洋·🐏",
          "userId": "1289566627",
          "type": 3,
          "img": this.xinyang,
          "cookie": "1",
          "gmvTodayAmountDouble": 0,
          "diveAmount": 600000,
          "giftTodayAmountDouble": 0,
          "createTime": 1744725047000
        }
      ]
    }
  },
  created () {
    // this.startTime = this.$route.query.startTime
    // this.endTime = this.$route.query.endTime
    // this.userList = userList.map((item) => {
    //   if (item.nickname.indexOf('716') === -1) {
    //     item.nickname += '·716'
    //   }
    //   return item
    // })
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
    }, 20000)
    // this.getAllUserInfo(2)
    // this.getAllUserInfo(3)
    this.getAllData(true)
    // this.getTestData()
    // 启动自动轮播
    // this.startAutoPlay()
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.carouselInterval)
  },
  methods: {
    pauseClick () {
      this.pause = !this.pause
      if (this.pause) {
        clearInterval(this.carouselInterval)
      } else {
        this.startAutoPlay()
      }
    },
    startAutoPlay () {
      this.carouselInterval = setInterval(() => {
        this.nextPage()
      }, 5000) // 每5秒切换一次
    },
    nextPage () {
      this.currentIndex = (this.currentIndex + 1) % 2
    },
    goToPage (index) {
      this.currentIndex = index
    },
    getAllUserInfo (type) {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/getListByType?type=${type}`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          console.log('所有主播数据：', res.data)
          // if (res.status === 200 && res.data && res.data.data && res.data.data.length) {
          //   this.userList = res.data.data.map((item) => {
          //     item.nickname += '·716'
          //     return item
          //   })
          // }
        })
    },
    getWidth (total, i) {
      let a = (total || 100) / this.maxNum * 70
      if (a > 20 && a < 30) {
        a = 30 - i
      }
      if (a < 20) {
        a = 20 - i / 2
      }
      return `${a}%`
    },
    getTestData () {
      const data = {
        1: 668989,
        2: 897979,
        3: 798988,
        6: 797897,
        7: 898989,
        9: 667767,
        10: 676878,
        11: 675655,
        12: 45546,
        14: 567575,
        18: 78787,
        19: 97755,
        20: 668989,
        21: 897979,
        22: 798988,
        23: 797897,
        // 24: 898989,
        // 25: 667767,
        // 26: 676878,
        // 27: 675655,
        // 28: 45546,
        // 29: 567575,
        // 30: 78787,
        // 31: 97755,
        // 32: 676878,
        // 33: 675655,
        // 34: 45546,
        // 35: 567575,
        // 36: 78787,
        // 37: 97755,
        // 38: 97755
      }
      this.loaded({}, true)
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime1216')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData1216') || '{}'), isFirst)
        return false
      }
      this.getData().then((res) => {
        console.log('日志数据：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime1216', moment().valueOf())
          window.localStorage.setItem('cacheData1216', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData1216') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData1216') || '{}'), isFirst)
      })
    },
    loaded (data, isFirst) {
      let total = 0
      const res = cloneDeep(this.group1).filter((item) => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        total += item.total
        return item
      })
      const res2 = cloneDeep(this.group2).filter((item) => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        total += item.total
        return item
      })
      this.dayTotal = total
      // res.sort((a, b) => b.total - a.total)
      // res2.sort((a, b) => b.total - a.total)

      this.topPosition = this.limit
      
      // console.log(res)
      if (isFirst) {
        this.data = res.map((item, i) => ({...item, total: 0}))
        this.data2 = res2.map((item, i) => ({...item, total: 0}))
      }
      this.dealData(this.data, res, isFirst)
      this.dealData2(this.data2, res2, isFirst)
    },
    getData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/gift`,
        method: 'get',
        headers: {
          'Content-Type': 'form-data/x-www-form-urlencoded'
        }
      })
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        // data.sort((a, b) => a.id - b.id)
        // newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      } else {
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = 0
        })
      }
      if (newData && newData.length) {
        // newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.data = this.data.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        // this.maxNum = this.data[0]?.total || this.maxNum
        if (i >= 40) {
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    dealData2 (data, newData, isFirst) {
      if (data && data.length) {
        // data.sort((a, b) => a.id - b.id)
        // newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      } else {
        newData.forEach((item, index) => {
          item.newNumber = item.total
          item.total = 0
        })
      }
      if (newData && newData.length) {
        // newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data2 = newData
      this.intervalFn2(isFirst)
    },
    intervalFn2 (isFirst) {
      let i = 0
      this.animating2 = true
      const interval = setInterval(() => {
        i++
        this.data2 = this.data2.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        // this.maxNum2 = this.data2[0].total || this.maxNum2
        if (i >= 40) {
          clearInterval(interval)
          this.animating2 = false
        }
      }, 50)
    },
    getOnce (n, o) {
      // 分多少次处理
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>
<style scoped>
.custom-carousel {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-wrapper {
  display: flex;
  width: 100%; /* 2 pages */
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.carousel-page {
  display: flex;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  position: relative;
}

.carousel-indicators {
  position: absolute;
  bottom: 50px;
  right: 15%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.carousel-indicators span {
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  background: #aaa;
  cursor: pointer;
  transition: background 0.3s;
  line-height: 50px;
  text-align: center;
  color: #fff;
}

.carousel-indicators span.active {
  background: #8c61ff;
}
.pause-con {
  position: absolute;
  bottom: 120px;
  right: 15%;
  width: 110px;
  height: 50px;
  transform: translateX(-50%);
}

.pause-con > button {
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 50px;
  text-align: center;
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/single1216/page1216.vue